import { colors, spacing, radius, shadows, typography } from "../theme";

export default function EnterpriseMetricCard({
  title = "Metric",
  value = 0,
  subtitle = "",
  color = "primary",
  onClick,
}) {
  const accent =
    {
      primary: colors.primary,
      success: colors.success,
      warning: colors.warning,
      danger: colors.danger,
      info: colors.info,
    }[color] || colors.primary;

  return (
    <div
      onClick={onClick}
      style={{
        background: colors.white,
        border: `1px solid ${colors.slate200}`,
        borderRadius: radius.xl,
        boxShadow: shadows.sm,
        padding: spacing.lg,
        cursor: onClick ? "pointer" : "default",
        transition: "all .2s ease",
      }}
    >
      <div
        style={{
          ...typography.caption,
          color: colors.slate500,
          textTransform: "uppercase",
          letterSpacing: ".05em",
        }}
      >
        {title}
      </div>

      <div
        style={{
          ...typography.metric,
          color: accent,
          marginTop: spacing.sm,
        }}
      >
        {value}
      </div>

      {subtitle ? (
        <div
          style={{
            ...typography.body,
            color: colors.slate500,
            marginTop: spacing.xs,
          }}
        >
          {subtitle}
        </div>
      ) : null}
    </div>
  );
}